import { IMaterial } from 'types/materials';

export const getMinIdForFields = (fields: IMaterial[] = []): number => {
    return fields?.reduce((maxId, current) => (current.id > maxId ? current.id : maxId), 0) + 1;
};
